

    import Vue from "vue";
    import { Prop } from "vue-property-decorator";
    import Component from "vue-class-component";

    @Component({})
    export default class PrivacyPolicy extends Vue {

        @Prop({ required: true })
        value!: boolean;

        hide () {
            this.$emit("input", false);
        }
    }
